
import { supabase } from '@/integrations/supabase/client';

export interface ConnectAccountDeletionResult {
  success: boolean;
  error?: string;
  results?: {
    total: number;
    successful: number;
    errors: number;
    details: Array<{
      accountId: string;
      stripeDeleted: boolean;
      databaseDeleted: boolean;
      success?: boolean;
      error?: string;
      note?: string;
    }>;
  };
}

export const deleteAllConnectAccounts = async (): Promise<ConnectAccountDeletionResult> => {
  try {
    console.log('🚀 Starting complete Connect account deletion...');
    
    const { data, error } = await supabase.functions.invoke('delete-connect-accounts');

    if (error) {
      console.error('❌ Error from delete-connect-accounts function:', error);
      return { 
        success: false, 
        error: error.message || 'Failed to delete Connect accounts' 
      };
    }

    if (!data?.success) {
      console.error('❌ Connect account deletion failed:', data?.error);
      return { 
        success: false, 
        error: data?.error || 'Failed to delete Connect accounts' 
      };
    }

    console.log('✅ Connect accounts deleted successfully:', data);
    return { 
      success: true, 
      results: data.results 
    };
  } catch (error) {
    console.error('❌ Exception in deleteAllConnectAccounts:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};

export const getConnectAccountStatus = async () => {
  try {
    console.log('📋 Fetching Connect account status...');
    
    const { data, error } = await supabase.functions.invoke('get-connect-status');

    if (error) {
      console.error('❌ Error from get-connect-status function:', error);
      return { 
        success: false, 
        error: error.message || 'Failed to get Connect status' 
      };
    }

    console.log('✅ Connect status retrieved:', data);
    return { 
      success: true, 
      data: data 
    };
  } catch (error) {
    console.error('❌ Exception in getConnectAccountStatus:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};
